import styles from "./style.module.scss";
import TopImage from "src/assets/accomodation_contract_top_image.jpg";

export const TopSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.backgroundImg}>
        <img src={TopImage} alt="accomodation contract" />
        <div className={styles.titleBox}>
          <h1>Accomodation Contract</h1>
          <p>宿泊約款</p>
        </div>
      </div>
    </section>
  );
};
